module.exports = __webpack_public_path__ + "img/fs_lola-regular-webfont.e3d4a8bb.svg";